import React, { useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";

//contents 
import HeroSection from '../components/LeadGen/HeroSection';
import TabbedFeaturesSection from '../components/LeadGen/TabbedFeaturesSection';
import OurClients from '../components/LeadGen/OurClients';
import Testimonials from '../components/LeadGen/Testimonials';
import GuaranteeSection from '../components/LeadGen/GuaranteeSection';
import StoryAndCTA from '../components/LeadGen/StoryAndCTA';
import WhyKinosDifferent from '../components/LeadGen/WhyKinosDifferent';
import FAQSection from '../components/LeadGen/FAQSection';


const Home = () => {
  // Smooth scroll for anchor links
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100, // Offset for fixed header
            behavior: 'smooth'
          });
        }
      });
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <div className="mt-2">
          <TabbedFeaturesSection />
          <OurClients />
          {/* <WhyKinosDifferent /> */}
          {/* <Testimonials /> */}
          <FAQSection />
          <GuaranteeSection />
          {/* <StoryAndCTA /> */}
        </div>
      </main>
      <Footer />
      
      {/* Global styles */}
      <style jsx global>{`
        /* Smooth scrolling for the entire page */
        html {
          scroll-behavior: smooth;
        }
        
        /* Animation for page elements */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        section {
          animation: fadeIn 0.6s ease-out;
        }
        
        /* Fix for fixed header causing content to be hidden */
        body {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

export default Home;